import {
  Clear,
  Close,
  Collections,
  FileCopy,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";
import {
  Box,
  Breadcrumbs,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { FieldArray, useFormikContext } from "formik";
import { MuiChipsInput } from "lib/mui-chips-input/index";
import {
  CustomFastAsyncSelect,
  CustomFastSelect,
} from "modules/Forms/components/form.legacy.component";
import PromoCategorySelect from "modules/Forms/components/promoCategorySelect.component";
import TextFieldWrapper from "modules/Forms/components/textFIeldWrapper.component";
import { PromoItemRowSchema } from "modules/PromoItems/services/promoItems.schemas";
import { BarcodeButton } from "modules/UI/components/BarcodeButton.component";
import { useActiveUser } from "modules/User/activeUser";
import React, { useEffect, useMemo } from "react";
import { PSL } from "../domains/psl.domain";
import PromoItemsService from "../services/promoItems.service";
import { useStaticData } from "modules/MasterData/service/staticData.hooks";
// import { SupplierStatus } from "../containers/create.container";

export const CustomCurrencySelect = ({
  value,
  onChange,
  required,
  disabled = false,
}: {
  value: any;
  onChange: any;
  required?: boolean;
  disabled?: boolean;
}) => {
  const { currencies } = useStaticData();
  return (
    <FormControl fullWidth size="small">
      <InputLabel htmlFor="currency-select" id="currency-select-label">
        Currency {required && <>*</>}
      </InputLabel>
      <Select
        disabled={disabled}
        size="small"
        fullWidth
        labelId="currency-select-label"
        id="currency-select"
        value={value}
        label="Currency"
        onChange={(e) => onChange(e.target.value)}
      >
        {currencies.map((currency) => {
          return (
            <MenuItem value={currency.CurrencyKey}>
              {currency.CurrencyKey}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export const CustomLanguageSelect = ({
  value,
  onChange,
  required,
  error,
  disabled,
}) => {
  const { languages } = useStaticData();
  return (
    <FormControl fullWidth size="small" disabled={disabled}>
      <InputLabel htmlFor="grouped-select">
        Language {required && "*"}
      </InputLabel>
      <Select
        size="small"
        fullWidth
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={value}
        label="Age"
        error={!!error}
        onChange={(e) => onChange(e.target.value)}
      >
        {languages.map((language) => {
          return <MenuItem value={language.id}>{language.name}</MenuItem>;
        })}
      </Select>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};

interface MaterialSelectorProps {
  companyCodes: string;
  spendCat3Code: string;
  initialValue: { value: string; label: string } | null;
  applyChange: (newValue: {
    value: string;
    label: string;
    uoM: string;
    mtart: string;
    materialGroup: string;
  }) => void;
  disabled: boolean;
  sx?: SxProps;
}
export const MaterialSelector = (props: MaterialSelectorProps) => {
  return (
    <Box style={{ position: "relative", zIndex: "20" }} sx={props.sx}>
      <CustomFastAsyncSelect
        disabled={props.disabled}
        onLoad={async (searchTerm) => {
          const results = await PromoItemsService.getPslAmdrMaterials({
            materialgroup: props.spendCat3Code,
            searchTerm,
            locationCompanyCodes: props.companyCodes,
          });

          return results?.map((option) => {
            return {
              value: option.id,
              label: `${option.name}`,
              ...option,
            };
          });
        }}
        onLoadLimit={3}
        customDisplay={(option) => `${option.value} - ${option.label}`}
        initialValue={props.initialValue}
        onChange={(value) => props.applyChange(value)}
      />
    </Box>
  );
};

export const PromoItemRow = React.memo((props: {
  readOnly: boolean;
  isEditMode: boolean;
  promoItem: any;
  defaultSpendCategories: any;
  locationCompanyCodes: any;
  promoItemIndex: number;
  onRemove: (promoItem: any) => void;
  onDuplicate: (promoItem: any) => void;
  onManageMedia: () => void;
  collapsed?: boolean;
}) => {
  const activeUser = useActiveUser();
  const staticData = useStaticData();
  const { values, setValues, setFieldValue, getFieldMeta } =
    useFormikContext<any>();
  console.log("PROMO ITEM VALUES", values);

  console.log(
    "CURRENT MATERIAL",
    values.materials?.[props.promoItemIndex]
  );
  const [open, setOpen] = React.useState(true);
  const pslClass = useMemo(() => {
    return new PSL(values.vendor);
  }, [values]);
  const isChildPsl = pslClass.isChildPsl();
  const isLocalVendor =
    values.vendor.pslIdWithPrefix?.startsWith("LP");


  const disableMaterialEditing =
  props.readOnly ||
  (props.isEditMode && isChildPsl && !isLocalVendor);
  // const isPriceFieldsReadOnly = props.readOnly || isChildPsl;
  const isPriceFieldsReadOnly = disableMaterialEditing;
  const [hover, setHover] = React.useState(false);

  // Calculate total media count including parent media files for child PSLs
  const materialParentMediaFiles = values.materials[props.promoItemIndex]?.parentMediaFiles;
  console.log("Jaffa:", {
    isChildPsl,
    isLocalVendor,
    pslPrefix: values.vendor.pslIdWithPrefix,
    readOnly: props.readOnly,
  });
  const totalMediaCount = useMemo(() => {
    const childMediaCount = props.promoItem.mediaFiles?.length || 0;
    if (isChildPsl) {
      const parentMediaCount =
        props.promoItem.parentMediaFiles?.length ||
        materialParentMediaFiles?.length ||
        0;
      return childMediaCount + parentMediaCount;
    }
    return childMediaCount;
  }, [props.promoItem.mediaFiles, props.promoItem.parentMediaFiles, materialParentMediaFiles, isChildPsl]);

  // // Helper function to determine if PSL editing should be disabled
  // const isPslEditingDisabled = useMemo(() => {
  //   if (isChildPsl) {
  //     return !(
  //       activeUser.hasAboveMarketRole() &&
  //       (values.vendor.statusId === SupplierStatus.MANDATORY ||
  //         values.vendor.statusId === SupplierStatus.SOLE_SOURCE)
  //     );
  //   }

  //   // For parent PSLs: disabled if campaign related
  //   return values.campaignRelated;
  // }, [isChildPsl, activeUser, values.vendor.statusId, values.campaignRelated]);

  const { data: amdrMaterials, isLoading: isLoadingAmdrMaterials } = useQuery({
    queryKey: ["amdrMaterials", props.promoItem.spendCat3Code, values.vendor],
    queryFn: () => {
      return PromoItemsService.getPslAmdrMaterials({
        materialgroup: props.promoItem.spendCat3Code,
        searchTerm: values.materials[props.promoItemIndex].materialNumber,
      });
    },
    initialData: [],
  });
  const { data: plants, isLoading: plantsLoading } = useQuery({
    queryKey: [
      "plants",
      values.vendor,
      values.materials[props.promoItemIndex].materialNumber,
    ],
    queryFn: () =>
      PromoItemsService.fetchPslAmdrPlantsV2({
        text: null,
        locationZones: values.vendor?.zones?.map((zone) => zone.id).join(","),
        locationMarkets: values.vendor?.markets
          ?.map((market) => market.id)
          .join(","),
        locationCompanyCodes: values.vendor?.companyCodes
          ?.map((companyCode) => companyCode.code)
          .join(","),
        materialNumber: values.materials[props.promoItemIndex].materialNumber,
      }),
    enabled: !!values.materials[props.promoItemIndex].materialNumber,
    initialData: [],
  });

  useEffect(() => {
    setOpen(!props.collapsed);
  }, [props.collapsed]);
  console.log("VENDOR", values.vendor);

  console.log({
    supplierCode: values.vendor?.supplierCode,
    childSupplierCode: values.vendor?.childSupplierCode,
    isChildPsl,
  });
  return isLoadingAmdrMaterials || plantsLoading ? (
    <>Loading...</>
  ) : (
    <Card
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      elevation={hover ? 5 : 1}
      sx={{
        padding: 2,
        borderRadius: 2,
        // backgroundColor: "#F9F9F9",
        background: "linear-gradient(#F9F9F9, #F5F5F5)",
        mb: 2,
        overflow: "visible",
      }}
    >
      <CardHeader
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
        avatar={!open ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        subheader={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <span>{values.materials[props.promoItemIndex].shortDescription}</span>
            {/* {values.materials[props.promoItemIndex].materialId && (
              <Typography
                variant="body2"
                component="span"
                sx={{ color: "text.secondary" }}
              >
                {`(Material ID #${values.materials[props.promoItemIndex].materialId})`}
              </Typography>
            )} */}
            <Typography
              variant="body2"
              component="span"
              sx={{
                color: "text.secondary",
                // color: values.materials[props.promoItemIndex].materialId
                //   ? "text.secondary"
                //   : "#f57c00",
                fontWeight: values.materials[props.promoItemIndex].materialId ? 400 : 600,
              }}
            >
              {`(Material ID ${values.materials[props.promoItemIndex].materialId
                ? `#${values.materials[props.promoItemIndex].materialId}`
                : "#New Item"
                })`}
            </Typography>
          </Box>
        }
        title={
          <Breadcrumbs separator={">"} sx={{ fontSize: ".8rem" }}>
            <Tooltip
              title={
                staticData.spendCategoriesHashMap[values.vendor.spendCat1Id]
                  ?.name
              }
            >
              {values.vendor.spendCat1Id &&
                staticData.spendCategoriesHashMap[values.vendor.spendCat1Id]
                  .code}
            </Tooltip>
            <Tooltip
              title={
                staticData.spendCategoriesHashMap[
                  values.materials[props.promoItemIndex]?.spendCat2Id
                ]?.name
              }
            >
              {values.materials[props.promoItemIndex].spendCat2Id &&
                staticData.spendCategoriesHashMap[
                  values.materials[props.promoItemIndex].spendCat2Id
                ].code}
            </Tooltip>
            <Tooltip
              title={
                staticData.spendCategoriesHashMap[
                  values.materials[props.promoItemIndex]?.spendCat3Id
                ]?.name
              }
            >
              {values.materials[props.promoItemIndex].spendCat3Id &&
                staticData.spendCategoriesHashMap[
                  values.materials[props.promoItemIndex].spendCat3Id
                ].code}
            </Tooltip>
            <Tooltip
              title={values.materials[props.promoItemIndex].materialName}
            >
              {values.materials[props.promoItemIndex].materialNumber}
            </Tooltip>
          </Breadcrumbs>
        }
        subheaderTypographyProps={{
          color: "primary",
          variant: "body2",
          fontWeight: "bolder",
        }}
        titleTypographyProps={{ color: "primary", variant: "body1" }}
        action={
          <ButtonGroup>
            <Button
              color="primary"
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                props.onManageMedia();
              }}
              startIcon={<Collections />}
            >
              Manage Media ({totalMediaCount})
            </Button>

            {disableMaterialEditing ? (
              <></>
            ) : (
              [
                //dont use react fragment here or it would cause layout issues with the button group, especially if it has rounded corners
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={(e) => {
                    e.stopPropagation();
                    props.onDuplicate(props.promoItem);
                  }}
                  startIcon={<FileCopy />}
                >
                  Duplicate
                </Button>,
                <Button
                  color="primary"
                  variant="outlined"
                  startIcon={<Close />}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.onRemove(props.promoItem);
                  }}
                >
                  Delete
                </Button>,
              ]
            )}
          </ButtonGroup>
        }
      />
      <Collapse in={open}>
        <CardContent>
          <Grid container spacing={2}>
            {props.promoItem.hasTaxonomy && (
              <Grid
                item
                xs={12}
                md={6}
                lg={4}
                xl={3}

              // sx={{
              //   width: 420,
              //   flexBasis: 420,
              //   flexShrink: 0,
              //   flexGrow: 1,
              // }}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <PromoCategorySelect
                      spendCat3Id={
                        values.materials[props.promoItemIndex].spendCat3Id
                      }
                      // disabled={
                      //   props.readOnly ||
                      //   isChildPsl ||
                      //   values.campaignRelated ||
                      //   !values.materials[props.promoItemIndex].spendCat3Id
                      // }
                      disabled={
                        disableMaterialEditing ||
                        values.campaignRelated ||
                        !values.materials[props.promoItemIndex].spendCat3Id
                      }
                      error={
                        getFieldMeta(
                          `materials[${props.promoItemIndex}]["promoCategoryId"]`
                        ).error
                      }
                      value={
                        values.materials[props.promoItemIndex][
                        "promoCategoryId"
                        ] as string
                      }
                      onChange={(e) => {
                        setFieldValue(
                          `materials[${props.promoItemIndex}].promoCategoryId`,
                          e?.id
                        );
                      }}
                      qualityApprovalRequired={(qualityApprovalRequired) => {
                        setFieldValue(
                          `materials[${props.promoItemIndex}].promoCategoryQualityRequired`,
                          qualityApprovalRequired
                        );
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
            // sx={{
            //   width: 420,
            //   flexBasis: 420,
            //   flexShrink: 0,
            //   flexGrow: 1,
            // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <FormControl
                    fullWidth
                    size="small"
                    disabled={
                      !!isLoadingAmdrMaterials ||
                      !values.materials[props.promoItemIndex].spendCat3Id
                    }
                    error={!!getFieldMeta("vendor.materialNumber").error}
                  >
                    <CustomFastAsyncSelect
                      // disabled={
                      //   props.readOnly ||
                      //   values.campaignRelated ||
                      //   isChildPsl ||
                      //   (pslClass.isAboveMarket() &&
                      //     activeUser.hasAtMarketRole()) ||
                      //   !values.materials[props.promoItemIndex].spendCat3Id
                      // }
                      disabled={
                        disableMaterialEditing ||
                        values.campaignRelated ||
                        (pslClass.isAboveMarket() && activeUser.hasAtMarketRole()) ||
                        !values.materials[props.promoItemIndex].spendCat3Id
                      }
                      onLoadLimit={3}
                      onLoad={(x) =>
                        PromoItemsService.getPslAmdrMaterials({
                          searchTerm: x,
                          materialgroup: props.promoItem.spendCat3Code,
                          locationCompanyCodes: props.locationCompanyCodes,
                        }).then((res) =>
                          res.map((el) => ({
                            value: el.id,
                            label: el.name,
                            matGrp: el.materialGroup,
                            uoM: el.uoM,
                          }))
                        )
                      }
                      customDisplay={(option) =>
                        `${option.value} - ${option.label}`
                      }
                      initialValue={() => {
                        // const selectedMaterial = amdrMaterials.find(
                        //   (option) => option.id === values.materials[props.promoItemIndex].materialNumber
                        // );
                        return {
                          value:
                            values.materials[props.promoItemIndex]
                              .materialNumber,
                          label:
                            values.materials[props.promoItemIndex].materialName,
                        };
                      }}
                      onChange={(value) => {
                        setFieldValue(
                          `materials[${props.promoItemIndex}].materialNumber`,
                          value?.value || ""
                        );
                        setFieldValue(
                          `materials[${props.promoItemIndex}].materialName`,
                          value?.label || ""
                        );
                        setFieldValue(
                          `materials[${props.promoItemIndex}].shortDescription`,
                          value?.label || ""
                        );
                      }}
                      styles={{
                        option: (base) => ({
                          ...base,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }),
                      }}
                      menuPortalTarget={document.body}
                    />
                    {!!getFieldMeta(
                      `materials[${props.promoItemIndex}]["materialNumber"]`
                    ).error && (
                        <FormHelperText error>
                          {
                            getFieldMeta(
                              `materials[${props.promoItemIndex}]["materialNumber"]`
                            ).error
                          }
                        </FormHelperText>
                      )}
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            {!activeUser.hasAboveMarketRole() && (
              <Grid
                item
                xs={12}
                md={6}
                lg={4}
                xl={3}
              // sx={{
              //   width: 420,
              //   flexBasis: 420,
              //   flexShrink: 0,
              //   flexGrow: 1,
              // }}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <CustomFastSelect
                      placeholder="Select plants"
                      loading={plantsLoading}
                      isMulti={true}
                      // disabled={props.readOnly}
                      disabled={disableMaterialEditing}
                      customDisplay={(option) =>
                        `${option.value} - ${option.label}`
                      }
                      initialValue={values.materials[
                        props.promoItemIndex
                      ].plants?.map((p) => ({ value: p.code, label: p.name }))}
                      options={plants.map((v) => ({
                        value: v.code,
                        label: v.name,
                      }))}
                      onChange={(value) =>
                        setFieldValue(
                          `materials[${props.promoItemIndex}].plants`,
                          value.map((v) => ({ code: v.value, name: v.label }))
                        )
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
            // sx={{
            //   width: 250,
            //   flexBasis: 250,
            //   flexShrink: 0,
            //   flexGrow: 1,
            // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <TextFieldWrapper
                    name={`materials[${props.promoItemIndex}].shortDescription`}
                    label={`Short Description
                        ${!(
                        PromoItemRowSchema.describe().fields[
                        "shortDescription"
                        ] as any
                      )?.optional
                        ? "*"
                        : ""
                      }`}
                    size="small"
                    fullWidth
                    disabled={disableMaterialEditing}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
            // sx={{
            //   width: 250,
            //   flexBasis: 250,
            //   flexShrink: 0,
            //   flexGrow: 1,
            // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    label={`Scope of Application
                        ${!(
                        PromoItemRowSchema.describe().fields[
                        "itemDescription"
                        ] as any
                      )?.optional
                        ? "*"
                        : ""
                      }`}
                    size="small"
                    fullWidth
                    error={
                      !!getFieldMeta(
                        `materials[${props.promoItemIndex}]["itemDescription"]`
                      ).error
                    }
                    helperText={
                      getFieldMeta(
                        `materials[${props.promoItemIndex}]["itemDescription"]`
                      ).error ?? null
                    }
                    value={
                      values.materials[props.promoItemIndex].itemDescription
                    }
                    onChange={(e) =>
                      setFieldValue(
                        `materials[${props.promoItemIndex}].itemDescription`,
                        e.target.value
                      )
                    }
                    disabled={disableMaterialEditing}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
            // sx={{
            //   width: 200,
            //   flexBasis: 200,
            //   flexShrink: 0,
            //   flexGrow: 1,
            // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    label={`Supplier Part Id
                        ${!(
                        PromoItemRowSchema.describe().fields[
                        "supplierPartId"
                        ] as any
                      )?.optional
                        ? "*"
                        : ""
                      }`}
                    size="small"
                    fullWidth
                    slotProps={{
                      input: {
                        endAdornment: !values.materials[props.promoItemIndex]
                          .supplierPartId ? null : (
                          <BarcodeButton
                            value={
                              values.materials[props.promoItemIndex]
                                .supplierPartId || ""
                            }
                          />
                        ),
                      },
                    }}
                    value={
                      values.materials[props.promoItemIndex].supplierPartId
                    }
                    onChange={(e) =>
                      setFieldValue(
                        `materials[${props.promoItemIndex}].supplierPartId`,
                        e.target.value
                      )
                    }
                    disabled={disableMaterialEditing}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* {activeUser.hasAboveMarketSupplierRole() && ( */}
            <>
              <Grid
                item
                xs={12}
                md={6}
                lg={4}
                xl={3}
              // sx={{
              //   width: 200,
              //   flexBasis: 200,
              //   flexShrink: 0,
              //   flexGrow: 1,
              // }}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <TextField
                      label={`Manufacturer Name
                        ${!(
                          PromoItemRowSchema.describe().fields[
                          "manufacturerName"
                          ] as any
                        )?.optional
                          ? "*"
                          : ""
                        }`}
                      size="small"
                      fullWidth
                      value={
                        values.materials[props.promoItemIndex]
                          .manufacturerName
                      }
                      onChange={(e) =>
                        setFieldValue(
                          `materials[${props.promoItemIndex}].manufacturerName`,
                          e.target.value
                        )
                      }
                      disabled={disableMaterialEditing}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                lg={4}
                xl={3}
              // sx={{
              //   width: 220,
              //   flexBasis: 220,
              //   flexShrink: 0,
              //   flexGrow: 1,
              // }}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <TextField
                      label={`Manufacturer Part Number
                        ${!(
                          PromoItemRowSchema.describe().fields[
                          "manufacturerPartNumber"
                          ] as any
                        )?.optional
                          ? "*"
                          : ""
                        }`}
                      size="small"
                      fullWidth
                      value={
                        values.materials[props.promoItemIndex]
                          .manufacturerPartNumber
                      }
                      slotProps={{
                        input: {
                          endAdornment: !values.materials[
                            props.promoItemIndex
                          ].manufacturerPartNumber ? null : (
                            <BarcodeButton
                              value={
                                values.materials[props.promoItemIndex]
                                  .manufacturerPartNumber || ""
                              }
                            />
                          ),
                        },
                      }}
                      onChange={(e) =>
                        setFieldValue(
                          `materials[${props.promoItemIndex}].manufacturerPartNumber`,
                          e.target.value
                        )
                      }
                      disabled={disableMaterialEditing}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </>
            {/* )} */}
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
            // sx={{
            //   width: 200,
            //   flexBasis: 200,
            //   flexShrink: 0,
            //   flexGrow: 1,
            // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    type="number"
                    label={`Supplier Lead Time
                        ${!(
                        PromoItemRowSchema.describe().fields[
                        "supplierLeadTime"
                        ] as any
                      )?.optional
                        ? "*"
                        : ""
                      }`}
                    size="small"
                    fullWidth
                    value={
                      values.materials[props.promoItemIndex].supplierLeadTime
                    }
                    onChange={(e) =>
                      setFieldValue(
                        `materials[${props.promoItemIndex}].supplierLeadTime`,
                        e.target.value
                      )
                    }
                    disabled={disableMaterialEditing}
                    slotProps={{
                      input: {
                        endAdornment: (
                          <Tooltip title="In days">
                            <span>day(s)</span>
                          </Tooltip>
                        ),
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
            // sx={{
            //   width: 420,
            //   flexBasis: 330,
            //   flexShrink: 0,
            //   flexGrow: 1,
            // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <MuiChipsInput
                    disabled={disableMaterialEditing}
                    error={
                      !!getFieldMeta(
                        `materials[${props.promoItemIndex}]["keyWords"]`
                      ).error
                    }
                    helperText={
                      getFieldMeta(
                        `materials[${props.promoItemIndex}]["keyWords"]`
                      ).error
                    }
                    value={values.materials[props.promoItemIndex].keyWords}
                    onChange={(newValue) =>
                      setFieldValue(
                        `materials[${props.promoItemIndex}].keyWords`,
                        newValue
                      )
                    }
                    size="small"
                    fullWidth
                    label={`Keywords *`}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
            // sx={{
            //   width: 140,
            //   flexBasis: 140,
            //   flexShrink: 0,
            //   flexGrow: 0,
            // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <CustomLanguageSelect
                    disabled={disableMaterialEditing}
                    required={
                      !(
                        PromoItemRowSchema.describe().fields[
                        "languageId"
                        ] as any
                      )?.optional
                    }
                    error={
                      getFieldMeta(
                        `materials[${props.promoItemIndex}]["languageId"]`
                      ).error
                    }
                    value={values.materials[props.promoItemIndex].languageId}
                    onChange={(newValue) =>
                      setFieldValue(
                        `materials[${props.promoItemIndex}].languageId`,
                        newValue
                      )
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              lg={8}
              xl={6}
            // sx={{
            //   width: 140,
            //   flexBasis: 140,
            //   flexShrink: 0,
            //   flexGrow: 0,
            // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <TextFieldWrapper
                    // minRows={}
                    size="small"
                    fullWidth
                    name={`materials[${props.promoItemIndex}].detailedDescription`}
                    label={"Detailed Description"}
                    multiline
                    disabled={disableMaterialEditing}
                  />
                  {/* <Editor
                    ref={quillRef}
                    readOnly={props.readOnly}
                    sx={{
                      border: `1px solid ${theme.palette.grey[400]}`,
                      borderRadius: theme.shape.borderRadius + "px",
                      "> *": {
                        border: "none !important",
                      },
                      ".ql-toolbar": {
                        borderBottom: `1px solid ${theme.palette.grey[400]} !important`,
                      },
                    }}
                    defaultValue={
                      values.materials[props.promoItemIndex]
                        .detailedDescription || "<em>Detailed Description</em>"
                    }
                    onChange={(value) => {
                      setFieldValue(
                        `materials[${props.promoItemIndex}].detailedDescription`,
                        value
                      );
                      setFieldValue(
                        `materials[${props.promoItemIndex}].notesToSupplier`,
                        value
                      );
                    }}
                  /> */}
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid // FIELD REMOVED BY REQUEST FROM ROBERTO LYRA
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
              hidden 
              // sx={{
              //   width: 140,
              //   flexBasis: 140,
              //   flexShrink: 0,
              //   flexGrow: 0,
              // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <TextFieldWrapper
                    fullWidth
                    size={"small"}
                    name={`materials[${props.promoItemIndex}].notesToSupplier`}
                    label={"Note to Supplier"}
                    multiline
                  />
                </Grid>
              </Grid>
            </Grid> */}
          </Grid>
          <h3>Pricing information</h3>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
            // sx={{
            //   width: 250,
            //   flexBasis: 250,
            //   flexShrink: 0,
            //   flexGrow: 1,
            // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <TextFieldWrapper
                    // disabled={
                    //   props.readOnly ||
                    //   isPslEditingDisabled
                    // }
                    disabled={isPriceFieldsReadOnly}
                    required={true}
                    type={"number"}
                    name={`materials[${props.promoItemIndex}].minimumOrderQuantity`}
                    label={`Minimum Order Quantity (MOQ)`}
                    size="small"
                    fullWidth
                    onChange={(e) => {
                      setFieldValue(
                        `materials[${props.promoItemIndex}].priceRanges[0].quantity`,
                        e.target.value
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
            // sx={{
            //   width: 250,
            //   flexBasis: 250,
            //   flexShrink: 0,
            //   flexGrow: 1,
            // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <TextFieldWrapper
                    // disabled={
                    //   props.readOnly ||
                    //   isPslEditingDisabled
                    // }
                    disabled={isPriceFieldsReadOnly}
                    required={true}
                    type={"number"}
                    name={`materials[${props.promoItemIndex}].minimumPurchaseQuantity`}
                    label={`Minimum Pack Quantity`}
                    size="small"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
            // sx={{
            //   width: 140,
            //   flexBasis: 140,
            //   flexShrink: 0,
            //   flexGrow: 1,
            // }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <CustomCurrencySelect
                    // disabled={
                    //   props.readOnly ||
                    //   isPslEditingDisabled
                    // }
                    disabled={isPriceFieldsReadOnly}
                    value={values.materials[props.promoItemIndex].currencyCode}
                    onChange={(newValue) =>
                      setFieldValue(
                        `materials[${props.promoItemIndex}].currencyCode`,
                        newValue
                      )
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              sx={{
                width: 150,
                flexBasis: 150,
                flexShrink: 0,
                flexGrow: 1,
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <FormControl fullWidth size="small">
                    <InputLabel
                      htmlFor="unit-of-measure-select"
                      id="unit-of-measure-label"
                    >
                      {`Unit of Measure
                        ${!(
                          PromoItemRowSchema.describe().fields[
                          "unitOfMeasure"
                          ] as any
                        )?.optional
                          ? "*"
                          : ""
                        }`}
                    </InputLabel>
                    <Select
                      // disabled={
                      //   props.readOnly ||
                      //   isPslEditingDisabled
                      // }
                      disabled={isPriceFieldsReadOnly}
                      size="small"
                      fullWidth
                      labelId="unit-of-measure-label"
                      id="unit-of-measure-select"
                      error={
                        !!getFieldMeta(
                          `materials[${props.promoItemIndex}]["unitOfMeasure"]`
                        ).error
                      }
                      value={
                        values.materials[props.promoItemIndex].unitOfMeasure
                      }
                      onChange={(e) =>
                        setFieldValue(
                          `materials[${props.promoItemIndex}].unitOfMeasure`,
                          e.target.value
                        )
                      }
                    >
                      {(
                        amdrMaterials
                          ?.find(
                            (m) =>
                              m.id ===
                              values.materials[props.promoItemIndex]
                                .materialNumber
                          )
                          ?.uoM?.split(",") || ["EA"]
                      ).map((uom) => {
                        return <MenuItem value={uom}>{uom}</MenuItem>;
                      })}
                    </Select>
                    {!!getFieldMeta(
                      `materials[${props.promoItemIndex}]["unitOfMeasure"]`
                    ).error && (
                        <FormHelperText error>
                          {
                            getFieldMeta(
                              `materials[${props.promoItemIndex}]["unitOfMeasure"]`
                            ).error
                          }
                        </FormHelperText>
                      )}
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <h3 style={{ marginBottom: 1 }}>Price Scales</h3>
          <Grid container spacing={2}>
            <Grid
              item
              sx={{
                width: 420,
                flexBasis: 420,
                flexShrink: 0,
                flexGrow: 1,
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <Table size="small" padding={"normal"}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Min. Quantity</TableCell>
                        <TableCell>Price</TableCell>
                        <TableCell>PricePer</TableCell>
                        <TableCell width={50}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <FieldArray
                        name={`materials[${props.promoItemIndex}].priceRanges`}
                      >
                        {(arrayHelpers) => (
                          <>
                            {(values.materials[
                              props.promoItemIndex
                            ]?.priceRanges || []).map((priceRange, index) => (
                              <TableRow key={index}>
                                <TableCell>
                                  <TextFieldWrapper
                                    // disabled={
                                    //   props.readOnly ||
                                    //   index === 0 ||
                                    //   isPslEditingDisabled
                                    // }
                                    disabled={
                                      isPriceFieldsReadOnly ||
                                      index === 0
                                    }
                                    name={`materials[${props.promoItemIndex}].priceRanges[${index}].quantity`}
                                    size="small"
                                    fullWidth
                                    variant="outlined"
                                    slotProps={{
                                      input: {
                                        endAdornment: (
                                          <>
                                            {
                                              values.materials[
                                                props.promoItemIndex
                                              ].unitOfMeasure
                                            }
                                          </>
                                        ),
                                      },
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextFieldWrapper
                                    // disabled={
                                    //   props.readOnly ||
                                    //   isPslEditingDisabled
                                    // }
                                    disabled={isPriceFieldsReadOnly}
                                    name={`materials[${props.promoItemIndex}].priceRanges[${index}].price`}
                                    size="small"
                                    fullWidth
                                    variant="outlined"
                                    slotProps={{
                                      input: {
                                        endAdornment: (
                                          <>
                                            {
                                              values.materials[
                                                props.promoItemIndex
                                              ].currencyCode
                                            }
                                          </>
                                        ),
                                      },
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextFieldWrapper
                                    // disabled={
                                    //   props.readOnly ||
                                    //   isPslEditingDisabled
                                    // }
                                    disabled={isPriceFieldsReadOnly}
                                    name={`materials[${props.promoItemIndex}].priceRanges[${index}].pricePer`}
                                    size="small"
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    inputProps={{ step: 1, min: 1 }}
                                    slotProps={{
                                      input: {
                                        endAdornment: (
                                          <>
                                            {
                                              values.materials[
                                                props.promoItemIndex
                                              ].unitOfMeasure
                                            }
                                          </>
                                        ),
                                      },
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  {index > 0 &&
                                    // !props.readOnly &&
                                    // !isPslEditingDisabled
                                    !isPriceFieldsReadOnly
                                    && (
                                      <Button
                                        fullWidth
                                        onClick={() =>
                                          arrayHelpers.remove(index)
                                        }
                                      >
                                        <Clear />
                                      </Button>
                                    )}
                                </TableCell>
                              </TableRow>
                            ))}
                            {
                              // !props.readOnly &&
                              //   !isPslEditingDisabled 
                              !isPriceFieldsReadOnly

                              && (
                                <TableRow>
                                  <TableCell colSpan={3}>
                                    <Button
                                      fullWidth
                                      onClick={() => {
                                        arrayHelpers.push({
                                          quantity: null,
                                          price: null,
                                          pricePer: 1,
                                        });
                                      }}
                                    >
                                      + Add Threshold
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              )}
                          </>
                        )}
                      </FieldArray>
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  );
});

export default PromoItemRow;
